import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import ClinicalImageTile from '../../../components/general/ClinicalImageTile';
import UnavailableImage from '../../../components/general/UnavailableImage';
import type { ImageBytes } from '../QualityCheck/imageMeta';

export const PHOTO_SIZE = 140;

/**
 * SKIN-576 — one photo in the placement panel and dialog: the bytes as `usePerImageDecrypt`
 * reports them, drawn by the shared clinical tile, its failure by `UnavailableImage`. Undefined
 * bytes (not asked yet) read as loading.
 */
export default function PlacementPhoto({ bytes, onRetry }: { bytes: ImageBytes | undefined; onRetry?: () => void }) {
    if (bytes?.state === 'ready') {
        return <ClinicalImageTile blobUrl={bytes.blobUrl} width={PHOTO_SIZE} height={PHOTO_SIZE} framed />;
    }
    if (bytes?.state === 'failed') {
        return <UnavailableImage failedAt={bytes.failedAt} error={bytes.error} onRetry={onRetry} size={PHOTO_SIZE} />;
    }
    return (
        <Box sx={{ width: PHOTO_SIZE, height: PHOTO_SIZE, display: 'flex', alignItems: 'center', justifyContent: 'center',
            border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
            <CircularProgress size={24} />
        </Box>
    );
}
